import React from "react";
import { UserFundraiserList } from "../../components";
import { TEAM_PAGE } from "../../constants";

export default function TeamFundraisers() {

    return <UserFundraiserList listType={TEAM_PAGE}/>
}